import React from 'react';
import { Option as CustomOption, } from '../option-list/option';
import { NativeOption } from './native';
import { useSelect } from './useSelect';
export function Option(props) {
    const { native } = useSelect();
    if (native)
        return React.createElement(NativeOption, { ...props });
    return React.createElement(CustomOption, { ...props });
}
//# sourceMappingURL=option.js.map